const CustomResourceApplySW = () => import('@/views/main/report/customResourceApply/CustomResourceApplySW.vue')
export default {
  path: '/main/report/customResourceApplySW',
  name: 'customResourceApplySW',
  component: CustomResourceApplySW,
  children: []
}
